import { Check } from 'lucide-react';
import { DuoPartner } from 'modules/jogador/tournaments/types';
import { Avatar } from 'shared/components/ui/Avatar';
import { useLocation } from 'react-router-dom';
import { useToast } from 'shared/components/ui/Toast';
import { copyInviteLink } from 'shared/utils/invite';

interface DuoPartnerCardProps {
  partner?: DuoPartner;
}

export function DuoPartnerCard({ partner }: DuoPartnerCardProps) {
  const toast = useToast();
  const { pathname } = useLocation();

  async function invite() {
    const copied = await copyInviteLink(pathname);
    toast({
      title: copied ? 'Link de convite copiado' : 'Convite pronto',
      description: 'Sua dupla tem 48h para aceitar e pagar a cota dela.',
    });
  }

  return (
    <div className="rounded-xl border border-border/70 p-4">
      <p className="text-xs font-semibold uppercase tracking-wide text-ink-secondary">Sua dupla</p>

      {partner && (
        <div className="mt-3 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Avatar name={partner.name} size="sm" />
            <span className="text-sm font-medium text-ink">
              {partner.name} · {partner.level}
            </span>
          </div>
          <span className="flex h-6 w-6 items-center justify-center rounded-full bg-primary text-surface">
            <Check className="h-3.5 w-3.5" strokeWidth={2.5} aria-hidden="true" />
          </span>
        </div>
      )}

      <button
        type="button"
        onClick={invite}
        className="mt-3 flex w-full items-center justify-between rounded-xl border border-dashed border-border px-3 py-2 text-sm text-ink-secondary transition-colors hover:border-primary"
      >
        + Convidar parceiro(a)
        <span className="font-medium text-primary">Buscar</span>
      </button>

      <p className="mt-2 text-xs text-ink-secondary">
        Convite expira em 48h. A vaga é confirmada quando as duas cotas estiverem pagas.
      </p>
    </div>
  );
}
